import { CancelOutlined, Close, KeyboardArrowRight, SwapHorizontalCircleOutlined } from '@mui/icons-material';
import { Button, Drawer, IconButton, Skeleton } from '@mui/material';
import { FC, useState } from 'react'
import { IExtract } from '../../../../modules/consume/domain/models/Extract'
import { IOrderPad } from '../../../../modules/consume/domain/models/OrderPad';
import ExtractOrders from './components/ExtractOrders';
import styles from './ExtractResume.module.scss'
import { useI18n } from '../../../../hooks/useI18n';
import { moneyMaskNumber } from '../../../../services/utils/Money';
export interface IExtractResumeProps {
    //propertys
    extract?: IExtract;
    orderPad?: IOrderPad;
    tag?: string;
    number?: string;
    onLoading?: boolean;
    onClickReadTag?: () => void;
    onClickCancelItem?: () => void;
    printExtract?: () => Promise<void>;
    onClickTransferItem?: () => void;
}

const ExtractResume: FC<IExtractResumeProps> = ({ extract, tag, number, onClickReadTag, orderPad, onLoading = true, onClickCancelItem, printExtract, onClickTransferItem }) => {    
    const { t } = useI18n();
    const [extractModalOpen, setExtractModalOpen] = useState(false)

    if (onLoading) {
        return (
            <div id={styles.ExtracLoading}>
                <Skeleton width={200} height={60} />
                <Skeleton width={100} height={60} />
                <div style={{ display: 'flex', gap: 8 }}>
                    <Skeleton style={{ display: 'flex', flex: 1 }} height={60} />
                    <Skeleton style={{ display: 'flex', flex: 1 }} height={60} />
                    <Skeleton style={{ display: 'flex', flex: 1 }} height={60} />
                    <Skeleton style={{ display: 'flex', flex: 1 }} height={60} />
                </div>
                <Skeleton width={120} height={40} />
            </div>
        );
    }
    if (!extract) {
        return (
            <div id={styles.ExtracNotFound}>
                <span>{t('catalog.extractNotFound')}</span>
                <div className={styles.readOrderPadTagButton} onClick={onClickReadTag} >{t('catalog.readOrderPadAgain')}</div>
            </div>
        );
    }
    return (
        <div id={styles.ExtractResume} >
            {/* <div className={styles.imageContainer} >
                <div className={styles.imageContainer} ></div>
            </div> */}
            <div className={styles.container} >
                <div className={styles.user} >
                    <div className={styles.user} >
                        <div className={styles.name} >
                            {extract.user?.name ?? t('catalog.nameNotInformed')}
                        </div>
                    </div>
                    <div className={styles.orderPad} >
                        {tag && <span >
                            {t('catalog.orderPad')}: <b>{tag}</b>
                        </span>}
                        {number && <span>
                            {t('catalog.table')}:<b> {number}</b>
                        </span>}
                    </div>
                    <div>
                        {orderPad?.openedAt}
                    </div>
                </div>

                <div className={styles.data} >
                    <div className={styles.item}>
                        <span>{moneyMaskNumber(extract.totalAmount)}</span>
                        <label>{t('catalog.totalConsumed')}</label>
                    </div>
                    <div className={styles.item}>
                        <span>{moneyMaskNumber(extract.totalToPayWithFee - extract.totalToPayWithoutFee)}</span>
                        <label>{t('catalog.serviceFee')}</label>
                    </div>
                    <div className={styles.item}>
                        <span>{moneyMaskNumber(extract.totalToPayWithFee)}</span>
                        <label>{t('catalog.totalToPay')}</label>
                    </div>
                    {!!extract.totalDiscount && <div className={styles.item}>
                        <span>{moneyMaskNumber(extract.totalDiscount)}</span>
                        <label>{t('catalog.discount')}</label>
                    </div>}
                    {/* <div className={styles.item}>
                    <span>{extract.paidAmount}</span>
                    <label>Total a pagar</label>
                </div> */}
                    {!!extract.minimumConsumption && <div className={styles.item}>
                        <span>{moneyMaskNumber(extract.minimumConsumption)}</span>
                        <label>{t('catalog.minimum')}</label>
                    </div>}
                    {/* <div className={styles.item}>
                    <span>{extract.totalToPayWithoutFee}</span>
                    <label>Total</label>
                </div> */}
                </div>
                <Button variant='text' onClick={() => setExtractModalOpen(true)} ><u>{t('catalog.viewExtract')}</u> <KeyboardArrowRight /> </Button>
                <Button variant='text' onClick={onClickCancelItem} ><u>{t('catalog.cancelItems')}</u><CancelOutlined /></Button>
                <Button variant='text' onClick={onClickTransferItem} ><u>{t('catalog.transferItems')}</u><SwapHorizontalCircleOutlined /></Button>
            </div>
            <Drawer anchor='right' open={extractModalOpen} onClose={() => setExtractModalOpen(false)}>
                <div className={styles.extractOrderDrawer}>
                    <div className={styles.headerTitle}>
                        <h2>{t('catalog.extract')}</h2>
                        <IconButton onClick={() => setExtractModalOpen(false)}>
                            <Close />
                        </IconButton>
                    </div>
                    <ExtractOrders extract={extract} printExtract={printExtract}/>
                </div>
            </Drawer>
        </div >
    )
}

export default ExtractResume;